import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { Validators, FormBuilder } from '@angular/forms';
import { LoginPage } from '../login/login';
import { ReserveData } from '../../providers/reserve';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';

@Component({
  selector: 'page-event-reserve',
  templateUrl: 'event-reserve.html'
})
export class EventReservePage {

  obs1: any;
  obs2: any;
  client: string;
  event: any;
  reserveId: string;
  viewForm: number = 0;
  reserveInfo: any;
  reserveChild: any;
  reserveType: string;
  reserveForm: any;
  payData: any;
  payForm: any;
  reserveData: any;
  application_code = 'RBUS-CO';
  api_key = 'hjjgOmuD0HA7P4tNwoMxdejiSvKnPs';
  textTranslate: any;
  disabledSend: any = false;

  constructor(public navCtrl: NavController, public params: NavParams, private formBuilder: FormBuilder, public reservProvider: ReserveData, public toastCtrl: ToastController, public auth: AuthData, public modalCtrl: ModalController, public loadingCtrl: LoadingController, translate: Translate, public view: ViewController) {
    translate.translateGroup(['Debe iniciar sesión antes de continuar', 'Nos encontramos sobreaforados en este momento. Por favor intente reservar más adelante', 'Reserva creada correctamente', 'Cargando', 'Ok', 'Reserva creada correctamente. Debe completar el proceso de pago', 'El número de reservas supera la cantidad permitida'])
    .then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.event = this.params.get('event');
    this.reserveId = this.params.get('reserveId');
    this.reserveType = this.params.get('type');
    this.reserveChild = this.params.get('reserveChild');

    this.reserveData = {
      quantity: 1,
      aditionalInfo: ''
    };

    this.reserveForm = this.formBuilder.group({
      quantity: ['', Validators.required],
      aditionalInfo: ['']
    });

    this.payData = {
      application_code: '',
      uid: '',
      auth_timestamp: '',
      auth_token: '',
      dev_reference: '',
      product_description: '',
      product_code: '',
      product_amount: '',
      success_url: '',
      failure_url: '',
      review_url: '',
    };

    this.payForm = this.formBuilder.group({
      application_code: ['', Validators.required],
      uid: ['', Validators.required],
      auth_timestamp: ['', Validators.required],
      auth_token: ['', Validators.required],
      dev_reference: ['', Validators.required],
      product_description: ['', Validators.required],
      product_code: ['', Validators.required],
      product_amount: ['', Validators.required],
      success_url: ['', Validators.required],
      failure_url: ['', Validators.required],
      review_url: ['', Validators.required],
    });

    this.obs1 = this.reservProvider.getReserve(this.client, this.reserveId).subscribe((data: any) => {
      this.reserveInfo = data;

      if (parseInt(this.reserveInfo.quota) <= parseInt(this.reserveInfo.numReserves)) {
        this.disabledSend = true;
      }

      this.viewForm = 1;
    });
  }

  next() {
    let loading = this.loadingCtrl.create({
      content: this.textTranslate['Cargando'],
      dismissOnPageChange: true
    });

    if (this.reserveForm.valid) {
      if (!this.auth.getUser().isAnonymous) {
        loading.present();

        switch(this.reserveType) {
          case 'Diary':
            this.reservProvider.createReserve(this.client, this.reserveChild, this.reserveId, this.reserveInfo, this.reserveData, 'Diary').then((result) => {
              let msg = '';

              if (this.reserveInfo.isPay) {
                // Continuo pay pass
                msg = this.textTranslate['Reserva creada correctamente. Debe completar el proceso de pago'];
                this.viewForm = 2;
                loading.dismiss();
              } else {
                // Create reserve
                msg = this.textTranslate['Reserva creada correctamente'];
                loading.dismiss();
                this.view.dismiss({reserveData: result});
              }

              let toast = this.toastCtrl.create({
                message: msg,
                duration: 5000
              });
              toast.present();
            }).catch((error) => {
              let toast = this.toastCtrl.create({
                message: this.textTranslate[error.error],
                duration: 3000
              });
              toast.present();
              loading.dismiss();
            })
          break;
        }
      } else {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event});
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        loading.dismiss();
        toast.present();
      }
    }
  }

  close() {
    this.view.dismiss();
  }

  closeListener() {
    console.log('Close observables Reserves')
    if (this.obs1) {
      this.obs1.unsubscribe();
    }
    if (this.obs2) {
      this.obs2.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-reserve/event-reserve.ts